<template>
    <div v-if="widget.type[locale]" class="card h-100  " :style="{'border': isSelected ? '3px  solid '+natureColor : '1px solid lightgray' }">
        <div class="triangle" v-if="isSelected" :style="{ 'border-color':natureColor + ' transparent transparent transparent'}">
        </div>
        <div class="card-body d-flex justify-content-center text-center flex-column p-8">
            <a href="#" class="text-gray-800 text-hover-primary d-flex flex-column">

                <img :src="widget.type['img']" alt="">

            <div class="fs-5 fw-bolder mb-2">{{widget.type[locale]}}</div>
            </a>
        </div>
    </div>
    
</template>
<script setup>
import { useLocales } from '@/composables/locales';
import { computed } from 'vue';

const props = defineProps({
    widget: {type: Object, required: true},
    isSelected: {type: Boolean, default: false}
})

const {locale} = useLocales()
const natureColor = computed(() => {
    return  $getCssVariable('--bs-primary')
})
const $getCssVariable = (variable) => window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim()

</script>
<style>
.triangle {
    position:relative;
}

.triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 30px 0 0;
 
}

.triangle::after {
  content: "✔";
  position: absolute;
  top: -35px;
  left: 0px;
  color: white;
  font-size: 20px;
  font-weight: bold;
}

</style>